import { GameWeek, TeamNamesByID } from '@shared/constants';
import { toSeasonWeekID, toWeekID } from '@shared/helpers';
import {
  setSelectedGame,
  setSelectedSeasonWeek,
  setSelectedTeam,
  setSelectedWeek,
  setSelectedYear,
} from 'app/slices/GamesSlice';
import { getByeWeekForSelectedWeekID } from 'app/slices/LeagueSlice';
import { store } from 'app/store';

export type WeeklyGamesPayload = {
  year: string;
  weekNum: GameWeek;
  byeWeekTeamNames: string[];
};

export const weeklyGamesLoader = async ({ params }: any): Promise<WeeklyGamesPayload | Response> => {
  const yearId = params.yearId;
  const weekId = params.weekId;
  const selectedWeekID = toWeekID(weekId);
  store.dispatch(setSelectedYear(yearId));
  store.dispatch(setSelectedWeek(selectedWeekID));
  store.dispatch(setSelectedSeasonWeek(toSeasonWeekID(yearId, selectedWeekID)));
  const byeWeekTeams = getByeWeekForSelectedWeekID(store.getState());

  const { gameSelected, teamSelected } = store.getState().nfl;

  if (gameSelected.length > 0) store.dispatch(setSelectedGame(''));
  if (teamSelected.length > 0) store.dispatch(setSelectedTeam(''));

  return {
    year: yearId,
    weekNum: selectedWeekID,
    byeWeekTeamNames: byeWeekTeams?.teamIDs.map((teamID) => TeamNamesByID[parseInt(teamID)]) ?? [],
  };
};
